import React, { useRef, useEffect } from 'react'
import styles from '@/styles/components/speaker.module.scss'

const SpeechTitlesModal = ({
  name,
  header,
  info,
  footer,
  infoClassName,
  closeIcon,
  outSideClick,
}) => {
  const divRef = useRef()

  useEffect(() => {
    function handleClickOutside(event) {
      if (divRef.current && !divRef.current.contains(event.target)) {
        outSideClick && outSideClick()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [divRef])

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-80">
        <div
          className={
            name == 'readmore'
              ? `uta-container top-10 relative ${styles.modalBorder}  bg-black maxXl:h-[82vh]`
              : `speech-titles-modal ${styles.modalBorder}  bg-black`
          }
        >
          <div className="w-full bg-black outline-none modal fade">
            <div
              className="w-auto pointer-events-none modal-dialog bg-none modal-dialog-scrollable"
              ref={divRef}
            >
              <div className="relative flex flex-col w-full px-4 py-4 text-current border-none rounded-md shadow-lg outline-none pointer-events-auto md:px-10 md:py-10 modal-content bg-clip-padding">
                <div className="modal-header">
                  <div className="relative flex justify-between " data-cy="speakerName">
                    {header}
                    {closeIcon}
                  </div>
                </div>
                <div className="sp-model-body maxMd:top-32" id="custom-scroll-bar">
                  <div className={infoClassName}>
                    {info} {footer}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SpeechTitlesModal
